import { usePostData } from "../../../../hooks";
import { EndPoints } from "../../../../Constants/endpoints";
import { PatientDetails } from "../../../../interface/GeneralResponse";

interface LinkPatientPayload {
  Id: number;
  PhoneNumber?: string;
  FullName?: string;
  Birthday?: string;
  Gender?: string;
}

export function useAddPatientActions({
  selectedPatient,
  countryId,
  onSuccess,
  onError,
}: {
  selectedPatient?: PatientDetails;
  countryId: number;
  onSuccess: () => void;
  onError: (msg: string) => void;
}) {
  const createPatient = usePostData(EndPoints.CreatePatient);
  const linkPatient = usePostData(EndPoints.LinkPatient);

  const create = (data: any) => {
    createPatient.mutate(
      {
        ...data,
        CountryId: countryId,
      },
      {
        onSuccess,
        onError: (e: any) => onError(e?.message),
      },
    );
  };

  const link = (data: LinkPatientPayload) => {
    if (!data.Id) return;

    linkPatient.mutate(data, {
      onSuccess,
      onError: (e: any) => onError(e?.message),
    });
  };

  return {
    create,
    link,
    isLoading: createPatient.isPending || linkPatient.isPending,
  };
}
